/**
 * Routing utilities for handling base URL configuration
 */

/**
 * Get the base URL from environment configuration
 */
export function getBaseUrl(): string {
  return import.meta.env.VITE_BASE_URL || '/';
}

/**
 * Create a URL with the base path prepended
 */
export function createUrl(path: string): string {
  const baseUrl = getBaseUrl();
  
  // Remove leading slash from path if base URL ends with slash
  if (baseUrl.endsWith('/') && path.startsWith('/')) {
    path = path.slice(1);
  }
  
  // Add leading slash to path if base URL doesn't end with slash
  if (!baseUrl.endsWith('/') && !path.startsWith('/')) {
    path = '/' + path;
  }
  
  return baseUrl + path;
}

/**
 * Create a Link component props object with proper href
 */
export function createLinkProps(to: string, props?: any) {
  return {
    ...props,
    to: createUrl(to)
  };
}

/**
 * Navigate programmatically with base URL
 */
export function navigateTo(path: string, navigate: (path: string) => void) {
  navigate(createUrl(path));
}

/**
 * Check if current path matches given path (considering base URL)
 */
export function isActivePath(currentPath: string, checkPath: string): boolean {
  const baseUrl = getBaseUrl();
  const normalizedCurrent = currentPath.replace(baseUrl, '').replace(/^\//, '');
  const normalizedCheck = checkPath.replace(/^\//, '');
  
  return normalizedCurrent === normalizedCheck;
}